import { globalApiHandler } from "../../services/services";
import { formatDate } from "../../utils/DateFormatter";

export const USER = {
  list: {
    success: "USER_LIST_SUCCESS",
    error: "USER_LIST_ERROR"
  },
  create: {
    success: "USER_CREATE_SUCCESS",
    error: "USER_CREATE_ERROR"
  },
  edit: {
    success: "USER_EDIT_SUCCESS",
    error: "USER_EDIT_ERROR"
  },
  update: {
    success: "USER_UPDATE_SUCCESS",
    error: "USER_UPDATED_ERROR"
  },
  disable: {
    success: "USER_DISABLE_SUCCESS",
    error: "USER_DISABLE_ERROR"
  },
  enable: {
    success: "USER_ENABLE_SUCCESS",
    error: "USER_ENABLE_ERROR"
  },
  delete: {
    success: "USER_DELETE_SUCCESS",
    error: "USER_DELETE_ERROR"
  }
};

export const userListAction = farmId => {
  let url = `/ntrac/user/farmId/${farmId}`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = formatDate(item.updatedAt);
          item.name = `${item.firstName} ${item.lastName}`;
          item.displayedRoleName =
            item.roleName === "FARM_EMPLOYEE"
              ? "Farm Employee"
              : "Account Admin";
        });
        dispatch({ type: USER.list.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const userCreateAction = userInfo => {
  let url = `/ntrac/user`;
  return dispatch => {
    globalApiHandler(url, "post", userInfo)
      .then(response => {
        dispatch({ type: USER.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const userEditAction = data => {
  return dispatch => {
    dispatch({ type: USER.edit.success, data });
  };
};

export const userUpdateAction = userInfo => {
  let url = `/ntrac/user/${userInfo.id}`;
  return dispatch => {
    globalApiHandler(url, "put", userInfo)
      .then(response => {
        dispatch({ type: USER.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const userDisableAction = id => {
  let url = `/ntrac/user/disable/${id}`;
  return dispatch => {
    globalApiHandler(url, "put", {})
      .then(response => {
        dispatch({ type: USER.disable.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const userEnableAction = id => {
  let url = `/ntrac/user/enable/${id}`;
  return dispatch => {
    globalApiHandler(url, "put", {})
      .then(response => {
        dispatch({ type: USER.enable.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const userDeleteAction = () => {};



// WEBPACK FOOTER //
// ./src/modules/users/action.js